import { LocaleContext } from 'components/MainComponent/MainComponent'
import { useContext } from 'react'
import styled from 'styled-components'

export const LeberDiagramm = ({
  opacity,
  alcoholcolor,
  bgcolor,
  coalcolor,
  oxygencolor,
}: {
  opacity: number
  alcoholcolor: string
  bgcolor: string
  coalcolor: string
  oxygencolor: string
}) => {
  const TEXT = useContext(LocaleContext)
  const { liverdiagramm } = TEXT

  return (
    <g style={{ opacity }}>
      <g style={{ transform: 'scale(1.08)' }}>
        <g>
          <rect
            x='40.917'
            y='.996'
            width='1.195'
            height='.398'
            fill={coalcolor}
          />
          <path
            d='M39.921,3.187c-.592,0-1.082,.431-1.177,.996h-.833c-.084-.5-.478-.894-.978-.978v-1.014h-.398v1.014c-.5,.084-.894,.478-.978,.978h-1.014v.398h1.014c.084,.5,.478,.894,.978,.978v1.014h.398v-1.014c.5-.084,.894-.478,.978-.978h.833c.084,.5,.478,.894,.978,.978v1.014h.398v-1.014c.5-.084,.894-.478,.978-.978h1.014v-.398h-1.014c-.095-.565-.585-.996-1.177-.996Z'
            fill={coalcolor}
          />
          <path
            d='M12.179,23.751c-.095-.565-.585-.996-1.177-.996s-1.082,.431-1.177,.996h-.833c-.084-.5-.478-.894-.978-.978v-1.014h-.398v1.014c-.5,.084-.894,.478-.978,.978h-1.014v.398h1.014c.084,.5,.478,.894,.978,.978v1.014h.398v-1.014c.5-.084,.894-.478,.978-.978h.833c.084,.5,.478,.894,.978,.978v1.014h.398v-1.014c.5-.084,.894-.478,.978-.978v-.398Z'
            fill={coalcolor}
          />
          <rect
            x='11.884'
            y='48.765'
            width='1.195'
            height='.398'
            fill={coalcolor}
          />
          <path
            d='M12.065,45.578c-.095-.565-.585-.996-1.177-.996s-1.082,.431-1.177,.996h-.833c-.084-.5-.478-.894-.978-.978v-1.014h-.398v1.014c-.5,.084-.894,.478-.978,.978h-1.014v.398h1.014c.084,.5,.478,.894,.978,.978v1.014h.398v-1.014c.5-.084,.894-.478,.978-.978h.833c.095,.565,.585,.996,1.177,.996s1.082-.431,1.177-.996v-.398Z'
            fill={coalcolor}
          />
        </g>
        <g>
          <g>
            <circle cx='42.637' cy='1.195' r='.723' fill={oxygencolor} />
            <circle cx='36.734' cy='1.667' r='.723' fill={oxygencolor} />
            <circle cx='36.734' cy='7.098' r='.723' fill={oxygencolor} />
            <circle cx='39.921' cy='7.098' r='.723' fill={oxygencolor} />
            <circle cx='34.018' cy='4.383' r='.723' fill={oxygencolor} />
            <circle cx='42.637' cy='4.383' r='.723' fill={oxygencolor} />
          </g>
          <g>
            <circle cx='7.814' cy='21.235' r='.723' fill={oxygencolor} />
            <circle cx='7.814' cy='26.666' r='.723' fill={oxygencolor} />
            <circle cx='11.002' cy='26.666' r='.723' fill={oxygencolor} />
            <circle cx='5.099' cy='23.951' r='.723' fill={oxygencolor} />
            {/* <circle cx='13.717' cy='23.951' r='.723' fill={alcoholcolor} /> */}
          </g>
          <g>
            <circle cx='13.603' cy='48.964' r='.723' fill={oxygencolor} />
            <circle cx='7.7' cy='43.061' r='.723' fill={oxygencolor} />
            <circle cx='7.7' cy='48.492' r='.723' fill={oxygencolor} />
            <circle cx='4.985' cy='45.777' r='.723' fill={oxygencolor} />
            {/* <circle cx='13.603' cy='45.777' r='.723' fill={oxygencolor} /> */}
          </g>
        </g>
        <path
          d='M10.906,32.03h10.818v3.383H10.906v4.16h.211l-.255,.952-.255-.952h.211v-4.16H0v-3.383H10.818v-3.86h.088v3.86ZM35.308,13.067v-1.572H15.583v1.502c-2.631,.024-4.765,2.173-4.765,4.812v.047h-.211l.232,.864h.047l.232-.864h-.211v-.047c0-2.591,2.094-4.701,4.677-4.725v1.793h19.725v-1.723c2.631-.024,4.765-2.173,4.765-4.812h-.088c0,2.591-2.094,4.701-4.677,4.725ZM41.116,1.195c0-.66-.535-1.195-1.195-1.195s-1.195,.535-1.195,1.195c0,.592,.431,1.082,.996,1.177v1.014h.398v-1.014c.565-.095,.996-.585,.996-1.177ZM10.364,21.773v1.181h.398v-1.02c.077,.016,.157,.024,.239,.024s.162-.008,.239-.024v1.02h.398v-1.181c.335-.212,.558-.584,.558-1.01,0-.66-.535-1.195-1.195-1.195s-1.195,.535-1.195,1.195c0,.425,.223,.798,.558,1.01Zm.723,26.014v-1.014h-.398v1.014c-.565,.095-.996,.585-.996,1.177,0,.66,.535,1.195,1.195,1.195s1.195-.535,1.195-1.195c0-.592-.431-1.082-.996-1.177Zm-.199-6.392c-.66,0-1.195,.535-1.195,1.195,0,.425,.223,.798,.558,1.01v1.181h.398v-1.02c.077,.016,.157,.024,.239,.024s.162-.008,.239-.024v1.02h.398v-1.181c.335-.212,.558-.584,.558-1.01,0-.66-.535-1.195-1.195-1.195Z'
          fill={alcoholcolor}
        />
      </g>

      <AnnoYellow x={24} y={2} fill={alcoholcolor}>
        {liverdiagramm[0]}
      </AnnoYellow>
      <AnnoYellow x={14} y={23} fill={alcoholcolor}>
        {liverdiagramm[1]}
      </AnnoYellow>
      <AnnoYellow x={3} y={57} fill={alcoholcolor}>
        {liverdiagramm[2]}
      </AnnoYellow>
      <AnnoBlue x={19} y={14.7} fill={bgcolor}>
        {liverdiagramm[3]}
      </AnnoBlue>
      <AnnoBlue x={2.4} y={36.9} fill={bgcolor}>
        {liverdiagramm[4]}
      </AnnoBlue>
      <Key transform={`translate(${30},${40})`}>
        <g>
          <circle r={1} fill={coalcolor} />
          <text x={2} y={1}>
            {liverdiagramm[5]}
          </text>
        </g>
        <g transform={`translate(${0},${3})`}>
          <circle r={1} fill={oxygencolor} />
          <text x={2} y={1}>
            {liverdiagramm[6]}
          </text>
        </g>
        <g transform={`translate(${0},${6})`}>
          <circle
            r={1}
            fill={alcoholcolor}
            stroke={'var(--site-background)'}
            strokeWidth={0.2}
          />
          <text x={2} y={1}>
            {liverdiagramm[7]}
          </text>
        </g>
      </Key>
    </g>
  )
}

const Key = styled.g`
  text {
    fill: var(--site-background);
    font-size: 2px;
  }
`

const AnnoYellow = styled.text`
  font-size: 1.5px !important;
  font-weight: 700;
`
const AnnoBlue = styled.text`
  font-size: 1.45px !important;
  /* fill: var(--blue-dark-1); */
`
